<template>
  <v-container fluid>
    <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
      <v-col cols="12" md="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">Documentos</div>
              <div class="text text--thin mb-2">Realizar novo upload de documento: <br>Máximo de 5Mb</div>
              <v-btn @click="dialog = true" color="primary" class="mt-1"><v-icon class="mr-1">note_add</v-icon>Novo documento</v-btn>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>add</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div class="mt-3">
      <v-expansion-panels accordion focusable class="mb-1">
        <v-expansion-panel v-for="doc in documentos" :key="doc.dca_id" class="mb-3">
          <v-expansion-panel-header>
            <div class="text-h2">
              {{doc.dca_nome}}
            </div>
            <div class="d-flex flex-row-reverse">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click.native.stop="openDialogCategoriaDelete(doc)" class="mr-4">
                    delete
                  </v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click.native.stop="openDialogCategoria(doc)" class="mr-3">
                    edit
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
            </div>
            <template v-slot:actions>
              <v-icon large>
                expand_more
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-data-table
              :headers="headers"
              :items="doc.documentos"
              :search="search"
              multi-sort
              loading-text="Carregando... Por favor aguarde"
              :loading="carregando"
              class="elevation-1 base_table mt-4"
              :footer-props="{
                itemsPerPageOptions: [5,10,15,20,25,50,100],
                showFirstLastPage: true,
                firstIcon: 'skip_previous',
                lastIcon: 'skip_next',
                prevIcon: 'chevron_left',
                nextIcon: 'chevron_right'
              }"
              :header-props="{
                sortIcon: 'north',
              }"
            >
              <template v-slot:top>
                <v-row no-gutters align="center" justify="space-between">
                  <div class="py-2 px-2">
                    <v-row no-gutters>
                      <v-text-field
                        clearable
                        hide-details=""
                        clear-icon="close"
                        v-model="search"
                        outlined
                        label="Busca"
                      ></v-text-field>
                    </v-row>
                  </div>
                </v-row>
              </template>
              <template v-slot:item.doc_criado_em="{ item }">
                {{$root.Formatter.formatDate(item.doc_criado_em)}}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-row no-gutters align="center" justify="center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openDialog(item)" color="primary" class="mr-2">
                        edit
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                        delete
                      </v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="downloadDocument(item)" color="primary" class="ml-2">
                        download
                      </v-icon>
                    </template>
                    <span>Baixar</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{documento.uuid_doc_id ? 'Editar' : 'Novo'}} documento
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formDocumento">
          <v-text-field
            autofocus
            v-model="documento.doc_nome"
            label="Nome*"
            :rules="[rules.required]"
            outlined
            :disabled="salvando"
            :loading="salvando"
          ></v-text-field>
          <v-autocomplete
            v-model="documento.uuid_dca_id"
            autocomplete="off"
            :items="categorias"
            :loading="salvando"
            :disabled="salvando"
            :rules="[rules.required]"
            label="Categoria*"
            append-icon="expand_more"
            append-outer-icon="add"
            outlined
            @click:append-outer="openDialogCategoria(categoria)"
          ></v-autocomplete>
          <v-autocomplete
            v-model="documento.uuid_gru_id"
            autocomplete="off"
            :items="grupos"
            :loading="salvando"
            :disabled="salvando"
            :rules="[rules.required]"
            label="Quem pode ver esse documento?*"
            append-icon="expand_more"
            outlined
          ></v-autocomplete>
          <v-textarea
            outlined
            no-resize
            rows="3"
            v-model="documento.doc_descricao"
            :loading="salvando"
            :disabled="salvando"
            label="Descrição"
          ></v-textarea>
          <v-file-input
            show-size
            clearable
            ref="file"
            v-model="documento.doc_arquivo"
            prepend-icon="description"
            label="Arquivo*"
            clear-icon="close"
            truncate-length="50"
            :loading="salvando"
            :disabled="salvando"
            v-if="isObject(documento.doc_arquivo)"
            outlined
            :rules="[rules.required, rules.size]"
            hint="Tamanho máximo permitido: 10MB"
            persistent-hint
          ></v-file-input>
          <v-row no-gutters justify="start" align="center" v-if="documento.doc_arquivo && !isObject(documento.doc_arquivo)">
            <div v-if="documento.doc_arquivo">
              <img :alt="documento.doc_arquivo.split('/').pop()" src="../assets/img/document.gif" class="documento"/>
            </div>
            <div>
              <v-tooltip>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon @click="seeDocument(documento.doc_arquivo)" v-bind="attrs" v-on="on" color="primary">visibility</v-icon>
                </template>
                <span>Visualizar documento</span>
              </v-tooltip>
              <v-tooltip>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon @click="dialogDeletarDocumento = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                </template>
                <span>Remover documento</span>
              </v-tooltip>
            </div>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditDocument()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogCategoria"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{categoria.uuid_dca_id ? 'Editar' : 'Nova'}} categoria
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogCategoria()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formCategoria">
          <v-text-field
            autofocus
            v-model="categoria.dca_nome"
            label="Nome*"
            :rules="[rules.required]"
            outlined
            :disabled="salvando"
            :loading="salvando"
          ></v-text-field>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogCategoria()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditCategoria()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCategoriaDelete" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Categoria
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogCategoriaDelete = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover esta categoria?
          Ao remover, todos os documentos que pertencem a ela serão excluídos
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogCategoriaDelete = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeCategoria()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover documento
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDocumentDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover este documento?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDocumentDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeRegister()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarDocumento" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover documento
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarDocumento = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover o documento?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarDocumento = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeDocumento()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      search: '',
      total: 0,
      carregando: false,
      options: {},
      dialog: false,
      dialogDelete: false,
      dialogCategoriaDelete: false,
      dialogDeletarDocumento: false,
      documento: {
        doc_nome: '',
        doc_arquivo: '',
        doc_descricao: '',
        uuid_dca_id: null,
        uuid_gru_id: null
      },
      salvando: false,
      categoria: {
        dca_nome: ''
      },
      dialogCategoria: false,
      rules: {
        required: value => !!value || 'Obrigatório.',
        size: value => !value || value.size < 10000000 || 'Arquivo precisa ter menos que 10MB!'
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'doc_id'
        },
        { text: 'Nome', value: 'doc_nome' },
        { text: 'Cadastrado em', value: 'doc_criado_em' },
        { text: 'Descrição', value: 'doc_descricao' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 130
        }
      ],
      documentos: [],
      categorias: [],
      grupos: []
    }
  },
  watch: {
    options: {
      handler () {
        // this.loadFunctions()
      },
      deep: true
    }
  },
  methods: {
    async getDocumentos () {
      this.salvando = true
      await Api.get(`documentos/lista/categorias`)
        .then((res) => {
          if (res.data) {
            let info = []
            if (res.data.length > 0) {
              res.data.map(item => {
                let documentosArr = []
                item.documentos.map(doc => {
                  documentosArr.push({
                    doc_id: doc.doc_id,
                    doc_nome: doc.doc_nome,
                    doc_descricao: doc.doc_descricao,
                    doc_criado_em: doc.doc_criado_em,
                    uuid_doc_id: doc.uuid_doc_id,
                    doc_arquivo: doc.doc_arquivo,
                    uuid_dca_id: doc.categoria.uuid_dca_id,
                    uuid_gru_id: doc.grupo.uuid_gru_id
                  })
                })
                info.push({
                  uuid_dca_id: item.uuid_dca_id,
                  dca_id: item.dca_id,
                  dca_nome: item.dca_nome,
                  documentos: documentosArr
                })
              })
            }
            this.documentos = info
          }
          this.salvando = false
        })
        .catch((erro) => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: erro.response.data.status ? erro.response.data.status : 'Ops, ocorreu um erro ao buscar os documentos!',
            color: 'error'
          })
          console.log(erro)
        })
    },
    getCategorias () {
      Api.get(`documentos/categorias`)
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dca_id,
                text: item.dca_nome
              })
            })
            this.categorias = info
          }
        })
    },
    getGroups () {
      Api.get(`grupos`)
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_gru_id,
                text: item.gru_nome
              })
            })
            this.grupos = info
          }
        })
    },
    saveEditCategoria () {
      if (!this.$refs.formCategoria.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'documentos/categorias/novo'
      let editado = false
      if (this.categoria.uuid_dca_id) {
        endpoint = 'documentos/categorias/edita'
        editado = true
      }
      Api.post(endpoint, this.categoria)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Categoria atualizada com sucesso!' : 'Categoria cadastrada com sucesso!',
            color: 'success'
          })
          this.closeDialogCategoria()
          this.getDocumentos()
          this.getCategorias()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    saveEditDocument () {
      if (!this.$refs.formDocumento.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'documentos/novo'
      let editado = false
      if (this.documento.uuid_doc_id) {
        endpoint = 'documentos/edita'
        editado = true
      }
      const formData = new FormData()
      Object.keys(this.documento).map((key) => {
        if (key === 'doc_arquivo') {
          if (this.$refs.file) {
            formData.append(`doc_arquivo`, this.documento.doc_arquivo)
          }
        } else {
          if (this.documento[key] != null) {
            formData.append(key, this.documento[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Documento atualizado com sucesso!' : 'Documento cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getDocumentos()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeCategoria () {
      this.salvando = true
      Api.delete(`documentos/categorias/remove/${this.categoria.uuid_dca_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogCategoriaDelete = false
          this.salvando = false
          this.closeDialogCategoria()
          this.getDocumentos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover categoria!',
            color: 'error'
          })
        })
    },
    removeRegister () {
      this.salvando = true
      Api.delete(`documentos/remove/${this.documento.uuid_doc_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogDelete = false
          this.salvando = false
          this.closeDialog()
          this.getDocumentos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover documento!',
            color: 'error'
          })
        })
    },
    openDialogCategoria (item) {
      this.categoria = JSON.parse(JSON.stringify(item))
      this.dialogCategoria = true
    },
    removeDocumento () {
      this.documento.doc_arquivo = ''
      this.documento.remover_documento = true
      this.dialogDeletarDocumento = false
    },
    seeDocument (url) {
      const a = document.createElement('a')
      a.href = url
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    openDialog (item) {
      this.documento = item
      this.dialog = true
    },
    openDialogDelete (item) {
      this.documento = item
      this.dialogDelete = true
    },
    cancelDocumentDelete () {
      this.closeDialog()
      this.dialogDelete = false
    },
    openDialogCategoriaDelete (item) {
      this.categoria = item
      this.dialogCategoriaDelete = true
    },
    closeDialog () {
      this.dialog = false
      this.documento = {
        doc_nome: '',
        doc_arquivo: '',
        doc_descricao: '',
        uuid_dca_id: null,
        uuid_gru_id: null
      }
      if (this.$refs.formDocumento) {
        this.$refs.formDocumento.resetValidation()
      }
    },
    closeDialogCategoria () {
      this.dialogCategoria = false
      this.categoria = {
        dca_nome: ''
      }
    },
    async downloadDocument (item) {
      let a = document.createElement('a')
      a.href = item.doc_arquivo
      a.target = '_blank'
      a.download = item.doc_nome
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(item.doc_arquivo)
    },
    loadFunctions () {
      this.getDocumentos()
      this.getCategorias()
      this.getGroups()
    },
    loadContent () {
      this.loadFunctions()
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.documento {
  max-height: 250px;
  max-width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Documentos.vue